import { Card, Tooltip, Skeleton } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Masonry } from "@mui/lab";
import { nexusDataGrids } from "./constant";
import { useNavigate } from "react-router-dom";
import HTTP from "../../services/httpService";
import NexusHeader from "./NexusHeader";
import { SettingContext } from "../../routes";

const Nexus = () => {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [nexusCards, setNexusCards] = useState(null);
    const { rabbitQueue, selectedNexusHotelId, setSelectedNexusHotelId } =
        useContext(SettingContext);
    const navigate = useNavigate();

    async function fetchNexusData(gridPayload) {
        try {
            const nexusRes = await HTTP(
                "nexus/getNexusDashboardCounts",
                gridPayload,
            );
            if (nexusRes.success) {
                setNexusCards(nexusRes.data);
            }
        } catch (error) {
            console.log("error in fetching nexus Data", error);
        }
    }

    function handleFilterChange(hotelIds) {
        let gridPayload = {
            staff_id,
            hotel_ids: hotelIds,
        };
        gridPayload.all_selected = hotelIds.length > 0 ? false : true;
        fetchNexusData(gridPayload);
    }

    function updateHotelCount() {
        return handleFilterChange(selectedNexusHotelId);
    }

    useEffect(() => {
        let gridPayload = {
            staff_id,
            all_selected: selectedNexusHotelId.length > 0 ? false : true,
            hotel_ids: [...selectedNexusHotelId],
        };
        fetchNexusData(gridPayload);
    }, []);

    useEffect(() => {
        if (rabbitQueue && rabbitQueue?.flag === 101) {
            updateHotelCount();
        } else return;
    }, [rabbitQueue]);

    function gotoNexusCardDetails(key) {
        console.log("gotoNexusCardDetails", key);
        if (key === "hotel_count") {
            navigate("/nexus-hotels");
        } else if (key == "call_waiting_counts") {
            navigate("/nexus-agents-status", { state: key });
        } else {
            navigate("/nexus-agents-status", { state: key });
        }
    }

    return (
        <Card className="dashboard-container">
            <NexusHeader
                showBackButton={true}
                isHotelFilter={true}
                handleFilterChange={handleFilterChange}
                selectedHotelId={selectedNexusHotelId}
                setSelectedHotelId={setSelectedNexusHotelId}
                isRefreshAllowed={true}
                refreshData={() => {
                    let gridPayload = {
                        staff_id,
                        all_selected:
                            selectedNexusHotelId.length > 0 ? false : true,
                        hotel_ids: [...selectedNexusHotelId],
                    };
                    fetchNexusData(gridPayload);
                }}
                withTime={false}
            />
            <Masonry columns={1} spacing={1}>
                <div className="dashboard-count-card">
                    {nexusCards ? (
                        nexusDataGrids.map((item) => {
                            return (
                                <Card
                                    hoverable
                                    className="dashboard-counts"
                                    key={item.key}
                                    onClick={() =>
                                        gotoNexusCardDetails(item.key)
                                    }
                                >
                                    <div className="dashboard-counts-card-body">
                                        <div className="dashboard-counts-diff-new">
                                            <span className="dashboard-counts-card-body-value">
                                                {nexusCards[item.key]}
                                            </span>
                                            <span className="dashboard-counts-card-info">
                                                <Tooltip
                                                    placement="rightTop"
                                                    title={item?.info}
                                                >
                                                    <InfoCircleOutlined />
                                                </Tooltip>
                                            </span>
                                        </div>
                                        <span className="dashboard-counts-card-header-title">
                                            {item?.title}
                                        </span>
                                        <img
                                            src={item?.Icon}
                                            alt={""}
                                            className="dashboard-counts-card-header-icon"
                                        />
                                    </div>
                                </Card>
                            );
                        })
                    ) : (
                        <Skeleton
                            title={false}
                            paragraph={{ rows: 5, width: 40 }}
                        />
                    )}
                </div>
            </Masonry>
        </Card>
    );
};

export default Nexus;
